//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { GalleriesDeleteGalleryActionType } from '@galleries/actions/galleriesDeleteGalleryActions';
import { GALLERIES_ACTIONS } from '@galleries/constants/galleriesConstants';
import { IGalleriesDeleteGalleryModal } from '@galleries/models/galleriesStateModel';

const initialState: IGalleriesDeleteGalleryModal = {
  deleteGalleryName: '',
  errors: {
    deleteGalleryError: undefined,
  },
  isDeletingGallery: false,
  isDeleteGalleryModalOpen: false,
};

export default function GalleriesDeleteGalleryReducer(
  state: IGalleriesDeleteGalleryModal = initialState,
  action: GalleriesDeleteGalleryActionType,
): IGalleriesDeleteGalleryModal {
  switch (action.type) {
    case GALLERIES_ACTIONS.CLOSE_DELETE_GALLERY_MODAL: {
      return {
        ...state,
        isDeleteGalleryModalOpen: false,
      };
    }
    case GALLERIES_ACTIONS.OPEN_DELETE_GALLERY_MODAL: {
      return {
        ...state,
        isDeleteGalleryModalOpen: true,
      };
    }
    case GALLERIES_ACTIONS.REQUEST_DELETE_GALLERY: {
      return {
        ...state,
        isDeletingGallery: true,
      };
    }
    case GALLERIES_ACTIONS.RECEIVE_DELETE_GALLERY_SUCCEEDED: {
      return {
        ...state,
        isDeletingGallery: false,
        deleteGalleryName: '',
      };
    }
    case GALLERIES_ACTIONS.RECEIVE_DELETE_GALLERY_FAILED: {
      return {
        ...state,
        errors: {
          ...state.errors,
          deleteGalleryError: action.error,
        },
        isDeletingGallery: false,
      };
    }
    case GALLERIES_ACTIONS.CLEAR_DELETE_GALLERY_ERROR: {
      return {
        ...state,
        errors: {
          ...state.errors,
          deleteGalleryError: undefined,
        },
      };
    }
    case GALLERIES_ACTIONS.SET_DELETE_GALLERY_NAME: {
      return {
        ...state,
        deleteGalleryName: action.deleteGalleryName,
      };
    }
    default:
      return state;
  }
}
